import script from "./ToutesLivraisons.vue?vue&type=script&setup=true&lang=js"
export * from "./ToutesLivraisons.vue?vue&type=script&setup=true&lang=js"

import "./ToutesLivraisons.vue?vue&type=style&index=0&id=8ee2a776&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ee2a776"]])

export default __exports__